import { useState } from 'react';
import { useLocation } from 'react-router-dom';

export const useNavigateBack = (defaultLocation: string) => {
  const location = useLocation();
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const [backTo, _setBackTo] = useState<string>(location.state?.backTo ?? defaultLocation);

  return {
    backTo,
  };
};
